import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from './FadeIn';

function screenTitle(screen) {
  if (screen.brand) return screen.brand;
  if (screen.locationDescription) return screen.locationDescription;
  return `Screen ${screen.screenId}`;
}

export default function NetworkGalleryGrid({ screens = [], linkToNetwork = true }) {
  if (!screens.length) return null;

  return (
    <div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {screens.map((screen, i) => (
          <FadeIn key={screen.screenId} delay={i * 0.05}>
            <article className="rounded-xl overflow-hidden border border-invert-border bg-white">
              <div className="aspect-[4/3] bg-slate-100">
                {screen.listingPhotoUrl ? (
                  <img
                    src={screen.listingPhotoUrl}
                    alt={`INVERT screen at ${screenTitle(screen)}`}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-3xl text-slate-300">
                    📺
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-invert-navy text-sm">{screenTitle(screen)}</h3>
                {screen.locationDescription && (
                  <p className="text-xs text-slate-500 mt-1">{screen.locationDescription}</p>
                )}
              </div>
            </article>
          </FadeIn>
        ))}
      </div>
      {linkToNetwork && (
        <p className="text-center mt-6">
          <Link
            to="/network"
            className="text-sm font-semibold text-invert-orange hover:text-invert-orange-deep transition-colors"
          >
            Browse full network →
          </Link>
        </p>
      )}
    </div>
  );
}
